import Vue from 'vue'

class Helper {
    adaptTableHeaders(headers: any[], vue: Vue): void {
        headers.forEach(header => {
            //console.log("Change from '" + header.text + "' to '" + vue.$vuetify.lang.t(header.text) + "'")
            if (header.text) {
                if (header.text[0] == ':') {
                    header.text = header.text.substring(1);
                } else {
                    header.text = vue.$vuetify.lang.t('$vuetify.' + header.text);
                }
            } else {
                header.text = "";
            }

        })
    }
}

export const DataTableHelper: Helper = new Helper();
